export default {
  namespaced: true,
  state: {
    pollGroupId: null,
    badgeImage: null,
    groupArticles: true,
    groupResults: false,
    label: null,
    brandingName: null,
    brandingImage: null,
    brandingLink: null,
    pollIds: [],
    pollsWithCustomStyling: [],
    timingContext: null,
    userId: null,
    activePollIdIndex: -1,
    nextPollLoading: false,
    showCongrats: false,
    leaderboardEnabled: false,
    scoring: 'none',
  },
  getters: {
    pollGroupModeActive: (state) => {
      return state.activePollIdIndex !== -1;
    },
    hasNextPoll: (state) => {
      return !!state.pollIds[state.activePollIdIndex + 1];
    },
    isNextPollLoading: (state) => {
      return state.nextPollLoading;
    }
  },
  mutations: {
    setPollGroup(state, { 
      pollGroupId,
      badgeImage, 
      groupArticles,
      groupResults,
      label,
      brandingName,
      brandingImage,
      brandingLink,
      pollIds,
      pollsWithCustomStyling,
      timingContext,
      showCongrats,
      userId,
      leaderboardEnabled,
      scoring
    }) {
      state.pollGroupId = pollGroupId;
      state.badgeImage = badgeImage;
      state.groupArticles = groupArticles;
      state.groupResults = groupResults;
      state.label = label;
      state.brandingName = brandingName;
      state.brandingImage = brandingImage;
      state.brandingLink = brandingLink;
      state.pollIds = pollIds;
      state.pollsWithCustomStyling = pollsWithCustomStyling;
      state.timingContext = timingContext;
      state.showCongrats = showCongrats;
      state.leaderboardEnabled = leaderboardEnabled;
      state.scoring = scoring;
      state.userId = userId;
      state.leaderboardEnabled = leaderboardEnabled;
      state.scoring = scoring;
    },
    setActivePollIndex(state, index) {
      state.activePollIdIndex = index;
    },
    setBrandingName(state, brandingName) {
      state.brandingName = brandingName;
    },
    setBrandingImage(state, brandingImage) {
      state.brandingImage = brandingImage;
    },
    setBrandingLink(state, brandingLink) {
      state.brandingLink = brandingLink;
    },
    setLeaderboardEnabled(state, leaderboardEnabled) {
      state.leaderboardEnabled = leaderboardEnabled;
    },
    setScoring(state, scoring) {
      state.scoring = scoring;
    },
    setPollGroupId(state, value) {
      state.pollGroupId = value;

    }
  },
  actions: {
    async nextPoll({ state, commit, dispatch }) {
      state.nextPollLoading = true;
      commit('setActivePollIndex', state.activePollIdIndex + 1);
      await dispatch('poll/initPoll', state.pollIds[state.activePollIdIndex], { root: true });
      state.nextPollLoading = false;
    },
    reset({ commit }) {
      commit('setActivePollIndex', -1);
    },
    setBrandingName({ commit }, brandingName) {
      commit('setBrandingName', brandingName);
    },
    setBrandingImage({ commit }, brandingImage) {
      commit('setBrandingImage', brandingImage);
    },
    setBrandingLink({ commit }, brandingLink) {
      commit('setBrandingLink', brandingLink);
    },
    setLeaderboardEnabled({ commit }, brandingLink) {
      commit('setLeaderboardEnabled', brandingLink);
    },
    setScoring({ commit }, brandingLink) {
      commit('setScoring', brandingLink); 
    },
    clearPollGroupId({ commit }) {
      commit('setPollGroupId', null);
    }
  },
  modules: {
  }
};
